export * from "./interfaces";
export { default as Injex } from "./injex";